

import store from '../../../../../../redux/store'
const initialWindowWidth = store.getState()?.eventListenerSlice?.windowSize?.width
export const staticComponentValueConverter = (customization) => {
    const storeData = store.getState()
    const windowWidth = storeData?.eventListenerSlice?.windowSize?.width
    const xlSizeRatio = windowWidth > 1535 ? 1.25416803234 : 1
    if (!customization) return null
    const customizationClone = structuredClone(customization)
    Object.keys(customizationClone).forEach((key) => {
        const value = customizationClone[key]
        if (!value) return
        if (typeof value === "string" && value?.includes("px") && !value?.includes("http")) {
            const valueArray = value?.replaceAll("px", "")
                .split(/\s+/)
                .filter(Boolean)
                .map(Number);
            const newValueArray = valueArray.map((element) => Number(element) * xlSizeRatio)
            const newPxData = newValueArray.map((element) => element + "px").join(" ")
            customizationClone[key] = newPxData
            return
        }
        if (value === "stretch") {
            customizationClone[key] = "fill"
        }
        if (typeof value === "number") {
            customizationClone[key] = value * xlSizeRatio
        }
    })
    return customizationClone
}

